import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Priorities, Statuses, Task} from "../../../entities/Task";
import {TaskPageModel, TaskTypes} from "app/entities/PageModel";
import {AppConfig} from '../../../app.config';
import {productModels} from '../../../../environments/environment';

declare var $:any;

@Component({
  selector: 'app-popover-task',
  templateUrl: './popover-task.component.html',
  styleUrls: ['./popover-task.component.css']
})
export class PopoverTaskComponent implements OnInit {

  public _TaskPageModel : TaskPageModel = new TaskPageModel();

  @Input()
  set TaskPageModel(value : TaskPageModel)
  {
    if(value != null) {

      this.isLoading = false;
      this._TaskPageModel = value;
    }
  }



  @Input()
  ExternalTasks : Task[] = null;

  @Input()
  TaskType : number;
  //task : Task;

  chosenTask : Task;
  @Output()
  openModalEmitter = new EventEmitter();

  @Output()
  changePageEmitter = new EventEmitter();

  @Output()
  public trySetCurrentPage = new EventEmitter();
  @Output()
  public trySetPageSize = new EventEmitter();
  @Output()
  public tryGetTasksEmitter = new EventEmitter();

  Priorities = Priorities;

  Statuses = Statuses;

  public taskSearchFieldValue : string = "";
  public searchInput : string = "";

  @Input()
  public currentPage : number;


  public lastPageIndex : number = 0;
  //public taskCount : number = this.TaskPageModel.TotalCount;

  public pageSize : number = 10;

  public isLoading : boolean = false;

  public productModels = productModels;
  public currentProductModel : any;

  constructor(private appConfig : AppConfig) { }

  ngOnInit() {
    this.chosenTask = new Task();

    this.currentProductModel = this.appConfig.getConfig("productModel");

  }

  searchFieldKeyDownFunction(event)
  {
    if(event.keyCode === 13) {
      this.searchInput = this.taskSearchFieldValue;
      this.getTasksForPage(1);
    }
  }

  openModal(task : Task)
  {
    this.openModalEmitter.emit(task);
    /*Object.assign(this.chosenTask, task);
    $('#myModal').modal('show');*/
  }

  getLastPageIndex()
  {
    return this.lastPageIndex = this._TaskPageModel.TotalCount != 0 ? Math.ceil(this._TaskPageModel.TotalCount / this.pageSize) : 1;
  }

  getTasksForPage(pageIndex : number)
  {
    if(pageIndex <= this.lastPageIndex && pageIndex > 0) {
      this.isLoading = true;
      this.trySetCurrentPage.emit(pageIndex);
      //let pageModel = new TaskPageModel();
      //pageModel.PageIndex = pageIndex;
      //pageModel.PageSize = this.pageSize;
      //pageModel.Type = this.TaskType;
      //pageModel.SearchInput = this.searchInput;
      //pageModel.FilterType = this._TaskPageModel.FilterType;

      this._TaskPageModel.PageIndex = pageIndex;
      this._TaskPageModel.PageSize = this.pageSize;
      this._TaskPageModel.Type = this.TaskType;
      this._TaskPageModel.SearchInput = this.searchInput;

      this.tryGetTasksEmitter.emit(this._TaskPageModel);
    }
  }


  getTasksArray()
  {
    return this._TaskPageModel.Tasks ? this.ExternalTasks == null : this.ExternalTasks;
  }



}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/popover-task/popover-task.component.ts